export const initialState = {
    agreementsGroupByType: [],
    externalAccounts: [],
    modelAssetAllocationAssociatedFund: {},
    capitalGainsInformation: [],
    yearlyFee: 0.00,
    clientDetails: [],
    dedicatedTotal: 0.00,
};

function investmentProposalReducer(state = initialState, action) {
    switch (action.type) {
        case "UPDATE_INVESTMENT_PROPOSAL": {
            const newState = {
                  ...state,
                  ...action.payload,
                  externalAccounts: action.payload.externalAccounts.filter(externalAccount => externalAccount.isSelected)
            };
            return newState;
        }
        default:
            return state;
    }
}

export default investmentProposalReducer;
